import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-driver-available-dialog',
  templateUrl: './no-driver-available-dialog.component.html',
  styleUrls: ['./no-driver-available-dialog.component.scss']
})
export class NoDriverAvailableDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
